/**
 * TGAOrigin enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file TGAOrigin.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum TGAOrigin {
	BOTTOM_LEFT =  0x00,
	BOTTOM_RIGHT = 0x01,
	TOP_LEFT =     0x02,
	TOP_RIGHT =    0x03,
	SHIFT =        0x04,
	MASK =         0x30
};